var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 82,
    rx: 41,
    fill: "#FF7A00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.175 38.1949V38.6149C55.9179 39.5479 56.219 40.7576 56 41.9299L52.88 51.6799C52.2673 53.2679 50.7421 54.3165 49.04 54.3199H30.05C27.8161 54.2715 26.0238 52.4592 26 50.2249V33.3199C25.9997 30.2424 28.4727 27.736 31.55 27.6949H38C40.0711 27.6949 41.75 29.3739 41.75 31.4449C41.75 32.2734 42.4216 32.9449 43.25 32.9449H50C52.8702 32.986 55.1753 35.3245 55.175 38.1949ZM31.55 29.9449C29.686 29.9449 28.175 31.456 28.175 33.3199V43.9999L29.78 39.8299C30.377 38.2081 31.9218 37.1304 33.65 37.1299H52.025C52.2845 37.1074 52.5455 37.1074 52.805 37.1299C52.3626 35.965 51.2461 35.1948 50 35.1949H43.25C41.1823 35.1867 39.5082 33.5126 39.5 31.4449C39.5 30.6165 38.8284 29.9449 38 29.9449H31.55Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/Folder.3ce663be9ebd95355f48564ae596eac4.svg";
export { ForwardRef as ReactComponent };